module.exports = __webpack_public_path__ + "static/media/Page 5.bb46b7a7.mp4";